var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentPdf = function SvgDocumentPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19 18V9.25L12.75 3H6.5A2.5 2.5 0 0 0 4 5.5V18a2.5 2.5 0 0 0 2.5 2.5h10A2.5 2.5 0 0 0 19 18",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.75 4v3.75a2.5 2.5 0 0 0 2.5 2.5H18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.728 13.794q.93 0 1.428.33.498.324.498 1.068 0 .75-.504 1.086-.504.33-1.44.33h-.294V18H6.48v-4.098q.306-.06.648-.084a9 9 0 0 1 .6-.024m.06.798a4 4 0 0 0-.372.018v1.2h.294q.486 0 .732-.132t.246-.492a.57.57 0 0 0-.066-.288.43.43 0 0 0-.18-.18.7.7 0 0 0-.282-.096 2 2 0 0 0-.372-.03m3.19 2.646.15.012h.21q.7 0 1.037-.354.342-.354.342-.978 0-.654-.324-.99t-1.026-.336q-.096 0-.198.006-.102 0-.192.012zm2.705-1.32q0 .54-.168.942a1.7 1.7 0 0 1-.48.666 2 2 0 0 1-.75.396 3.5 3.5 0 0 1-.996.132q-.252 0-.588-.024a4.5 4.5 0 0 1-.66-.084v-4.05q.324-.06.672-.078.354-.024.606-.024.534 0 .966.12.438.12.75.378t.48.66.168.966M14.165 18v-4.158h2.784v.786h-1.848v.87h1.644v.786h-1.644V18z"
  })));
};
export default SvgDocumentPdf;